import { useEffect, useCallback, useContext } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker/entry-points/component.ts';

import {
	loadPanelSubExperiences,
	abortAllLoadPanelExperiencesOnEditPageEnded,
	abortAllLoadPanelExperiences,
} from './experienceTrackerHelpers.ts';

type UseTemplatePanelExperienceTrackerResponse = {
	abortTemplatePanelLoadExperiences: (reason: string) => void;
};

export const useLoadTemplatePanelExperienceTracker =
	(): UseTemplatePanelExperienceTrackerResponse => {
		const experienceTracker = useContext(ExperienceTrackerContext);

		useEffect(() => {
			return experienceTracker.subscribe(
				abortAllLoadPanelExperiencesOnEditPageEnded(experienceTracker, loadPanelSubExperiences),
			);
		}, [experienceTracker]);

		const abortExperiences = useCallback(
			(reason: any) => {
				abortAllLoadPanelExperiences(experienceTracker, loadPanelSubExperiences, reason);
			},
			[experienceTracker],
		);

		return {
			abortTemplatePanelLoadExperiences: abortExperiences,
		};
	};
